<template>
    <div>
        <div class="ql-editor" v-html="videoData.content"></div>

    </div>
</template>

<script>
export default {
    name: 'VideoContent',
    components: {

    },
    data() {
        return {
            content: "",
            videoData: '',
        }
    },
    methods: {
        // 获取数据列表
        getDataList() {
            this.videoData = this.$route.params.data
            let content = this.videoData.content
            // let c1 = content.replace(/<img width="100%;"/g, '<img');
            // let c2 = c1.replace(/<img/g, '<img width="100%"');
            // this.videoData.content = c2;

        },
       
    },
    created() {
        console.log(this.$route.params.data);
        this.getDataList()
    },

}
</script>

<style lang="less"></style>